import {Context, createContext} from 'react';

import InterfaceStore from "./InterfaceStore";
import I18nStore from "./i18nStore";
import OrganizationStore from "./OrganizationStore";
import CalendarStore from './CalendarStore';
import UserStore from './UserStore'
import ModalStore from "./ModalStore";
import StyleStore from './StyleStore';
import GridStore from './GridStore';

// load this file only once!

export const interfaceStore = new InterfaceStore();
export const userStore = new UserStore();
export const organizationStore = new OrganizationStore(userStore);
export const modalStore = new ModalStore();
export const calendarStore = new CalendarStore();
export const styleStore = new StyleStore(interfaceStore, organizationStore);
export const gridStore = new GridStore();
export const i18nStore = new I18nStore(organizationStore);

const allStores = {
    interfaceStore,
    organizationStore,
    i18nStore,
    modalStore,
    calendarStore,
    userStore,
    styleStore,
    gridStore,
};

export default allStores;

export const StoreContext = createContext(allStores) as Context<any>;

export function loadStores() {
    const interfaceStore = new InterfaceStore();
    const userStore = new UserStore();
    const organizationStore = new OrganizationStore(userStore);
    const modalStore = new ModalStore();
    const calendarStore = new CalendarStore();
    const styleStore = new StyleStore(interfaceStore, organizationStore);
    const gridStore = new GridStore();
    const i18nStore = new I18nStore(organizationStore);

    return {
        interfaceStore,
        organizationStore,
        modalStore,
        calendarStore,
        userStore,
        styleStore,
        gridStore,
        i18nStore,
    }
}
